export const REQURES_DOCUMENTATION = "requiresDocumentation";

export const IsOldNewClient = () => {
	const result = localStorage.getItem(REQURES_DOCUMENTATION);
	return result === "true";
};
